<div class="bg-th-blue mt-0 container-fluid py-2">
    <div class=" d-flex justify-content-between align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
        <a class="text-white f18 my-auto dirI">تکمیل شناسنامه ردیاب </a>
    </div>
</div>

<section *ngIf="!isScannerVisible" dir="rtl" class="d-flex justify-content-center align-items-center px-2 px-md-0">

    <div [formGroup]="sabtModelGps" class="row g-3 mx-auto w-100 w-md-75 p-2 p-md-4">

        <!-- بخش شناسه دستگاه و دکمه‌ها -->
        <div class="col-12">
            <div class="row g-2 align-items-end">
                <div class="col-12 col-md-6">
                    <label class="form-label">شناسه دستگاه</label>
                    <input inputmode="numeric" appNumericOnly maxlength="15" placeholder="شناسه دستگاه" 
                    [ngClass]="this.sabtModelGps.get('strUnitId')?.value == '' ? 'text-start' : 'text-end'"
                    class="form-control text-start bg-light" 
                    id="Imei" formControlName="strUnitId" [readonly]="imeIInp">
                </div>
                <div class="col-6 col-md-3">
                    <button class="btn btn-secondary w-100" (click)="openScanner()">
                        اسکن QR
                    </button>
                </div>
                <div class="col-6 col-md-3">
                    <button class="btn btn-primary w-100" (click)="Imei()">
                        بررسی شناسه 
                    </button>
                </div>
            </div>
        </div>

        <ng-container *ngIf="imeIInp">
            <!-- اطلاعات ردیاب -->
            <div class="col-12 col-md-6">
                <label class="form-label">نوع ردیاب *</label>
                <select class="form-select" formControlName="iGPS"> 
                    <option value=""> انتخاب کنید </option>
                    <option *ngFor="let item of gpsType" value="{{item.iGPS}}">
                        {{item.strComment}}
                    </option>
                </select>
            </div>
            <div class="col-12 col-md-6">
                <label class="form-label">شماره سیم کارت ردیاب *</label>
                <input inputmode="numeric" appNumericOnly maxlength="11" placeholder="مثال: 09120000000" 
                [ngClass]="this.sabtModelGps.get('strCellNo')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="strCellNo">
            </div>
    
            <!-- اطلاعات مالک -->
            <div class="col-12 col-md-4">
                <label class="form-label">نام و نام خانوادگی مالک *</label>
                <input type="text" placeholder="نام و نام خانوادگی" 
                class="form-control bg-light" formControlName="strFullName">
            </div>
            <div class="col-12 col-md-4">
                <label class="form-label">شماره موبایل مالک *</label>
                <input inputmode="numeric" appNumericOnly maxlength="11" placeholder="مثال: 09120000000" 
                [ngClass]="this.sabtModelGps.get('strMobile')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="strMobile">
            </div>
            <div class="col-12 col-md-4">
                <label class="form-label">کد ملی مالک *</label>
                <input inputmode="numeric" appNumericOnly maxlength="10" placeholder="کد ملی 10 رقمی" 
                [ngClass]="this.sabtModelGps.get('strPersonnelID')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="strPersonnelID">
            </div>
    
            <!-- اطلاعات خودرو -->
            <div class="col-12 col-md-4">
                <label class="form-label w-100">پلاک *</label>
        
                <div class="input-group bg-light" dir="ltr">
                    
                    <input inputmode="numeric" appNumericOnly formControlName="plak1" maxlength="2" class="form-control text-center bg-light border-end-1" placeholder="- -">
                    
                    <select formControlName="plak2" class="form-select text-center bg-light border-start-0 border-end-0" >
                        <option value="الف">الف</option>
                        <option value="ب">ب</option>
                        <option value="پ">پ</option>
                        <option value="ت">ت</option>
                        <option value="ج">ج</option>
                        <option value="د">د</option>
                        <option value="ز">ز</option>
                        <option value="س">س</option>
                        <option value="ص">ص</option>
                        <option value="ط">ط</option>
                        <option value="ع">ع</option>
                        <option value="ق">ق</option>
                        <option value="ک">ک</option>
                        <option value="ل">ل</option>
                        <option value="م">م</option>
                        <option value="ن">ن</option>
                        <option value="و">و</option>
                        <option value="ه">ه</option>
                        <option value="ی">ی</option>
                    </select>
                    
                    <input inputmode="numeric" appNumericOnly formControlName="plak3" maxlength="3" 
                        class="form-control text-center bg-light border-start-0" placeholder="- - -">
                    
                    <input inputmode="numeric" appNumericOnly formControlName="plak4" maxlength="2" 
                        class="form-control text-center bg-light border-start-1" placeholder="- -">
                </div>
    
            </div>
    
            <div class="col-12 col-md-4">
                <label class="form-label">VIN *</label>
                <input type="text" maxlength="17" placeholder="شماره شاسی 17 رقمی" 
                [ngClass]="this.sabtModelGps.get('strVIN')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="strVIN" style="text-transform: uppercase;">
            </div>
            <div class="col-12 col-md-4">
                <label class="form-label">رنگ *</label>
                <input type="text" placeholder="رنگ خودرو" 
                class="form-control bg-light" formControlName="strColor">
            </div>
    
            <!-- اطلاعات تکمیلی خودرو و دستگاه -->
            <div class="col-12 col-md-4">
                <label class="form-label">سال ساخت *</label>
                <input inputmode="numeric" maxlength="4" placeholder="مثال: 1398" 
                [ngClass]="this.sabtModelGps.get('iYearConstruction')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="iYearConstruction">
            </div>
            <div class="col-12 col-md-4">
                <label class="form-label">شماره پلمپ</label>
                <input inputmode="numeric" placeholder="شماره پلمپ" 
                class="form-control text-start bg-light" formControlName="strSecuritySealNumber">
            </div>
            
            <!-- حساب کاربری -->
            <div class="col-12 col-md-4">
                <label class="form-label">نام کاربری</label>
                <input type="text" placeholder="نام کاربری" 
                [ngClass]="this.sabtModelGps.get('strUserName')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="strUserName">
            </div>
    
            <!-- توضیحات -->
            <div class="col-12">
                <label class="form-label">توضیحات</label>
                <textarea placeholder="توضیحات تکمیلی" 
                class="form-control bg-light" formControlName="strComment" rows="3"></textarea>
            </div>
    
            <!-- فیلدهای (رمز عبور) -->
            <div class="col-12 col-md-6">
                <label class="form-label">رمز عبور</label>
                <input type="text" placeholder="رمز عبور" 
                [ngClass]="this.sabtModelGps.get('strPassword')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="strPassword">
            </div>
            <div class="col-12 col-md-6">
                <label class="form-label">تکرار رمز عبور</label>
                <input type="text" placeholder="تکرار رمز عبور" 
                [ngClass]="this.sabtModelGps.get('strRepeatPassword')?.value == '' ? 'text-start' : 'text-end'"
                class="form-control text-start bg-light" formControlName="strRepeatPassword">
            </div>
    
            <!-- دکمه ثبت -->
            <div class="col-12 mt-4 text-center">
                <button class="btn btn-success w-100" style="max-width: 300px;" (click)="sabtGps()" [disabled]="isLoading">
                    ثبت اطلاعات
                </button>
            </div>
        </ng-container>

    </div>

</section>


<div class="col-12 col-md-6 mx-auto p-2" *ngIf="isScannerVisible">
    <div class="card shadow-sm p-2 text-center">
        <zxing-scanner (scanSuccess)="onCodeResult($event)"></zxing-scanner>
        <button class="btn btn-danger mt-3" (click)="closeScanner()">
            لغو و بستن دوربین
        </button>
    </div>
</div>